import React from 'react';
import { View, Text, Button, TouchableOpacity, TextInput, Alert, Platform } from 'react-native';
import config from '../config';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18n from './../util/i18n';
import { login } from '../services/auth.service';

i18n.locale = navigator.language;

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = { passKey: '' };
    }

    // store pass key in local storage
    storePassKey = async (value) => {
        try {
            await AsyncStorage.setItem('passKey', value)
        } catch (e) {
            console.log(e);
        }
    }

    storeToken = async (value) => {
        try {
            await AsyncStorage.setItem('token', value)
        } catch (e) {
            console.log(e);
        }
    }

    // Login
    login = async () => {
        try {

            if (!this.state.passKey) {
                if (Platform.OS === 'web') {
                    alert(i18n.t('enter_pass_key'));
                } else {
                    Alert.alert(i18n.t('enter_pass_key'));
                }
                return;
            }

            let response = await login({ passKey: this.state.passKey });
            if (response?.error) {
                if (Platform.OS === 'web') {
                    alert(i18n.t('wrong_pass_key'));
                } else {
                    Alert.alert(i18n.t('wrong_pass_key'));
                }
            } else {
                await this.storeToken(response.token);
                this.props.navigation.replace('Home');
                // reset the navigation stack and navigate to login page
                this.props.navigation.reset({
                    index: 0,
                    routes: [{ name: 'Home' }],
                });
            }
        } catch (error) {
            console.log(error);
        }
    }


    getPassKey = async () => {
        try {
            const value = await AsyncStorage.getItem('passKey')
            if(value !== null) {
                this.setState({ passKey: value });
                this.props.navigation.replace('Home');
                return value;
            }
        } catch(e) {
            console.log(e);
        }
    }

    componentDidMount() {
        this.getPassKey()
    }


  render() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <TextInput
            placeholder={i18n.t('pass_key')}
            style={{ height: 40, borderColor: 'gray', borderWidth: 1, borderRadius: 5, padding: 5, textAlign: 'center', margin: 10, width: '80%' }}
            onChangeText={(text) => {
                this.setState({ passKey: text });
            }}
            onSubmitEditing={() => {
                this.login();
            }}
        />
        <TouchableOpacity
            style={{ backgroundColor: 'blue', padding: 10, borderRadius: 5, marginTop: 10, width: '80%', alignItems: 'center' }}
            onPress={() => {
                this.login();
                // if (this.state.passKey == config.passKey) {
                //     this.storePassKey(this.state.passKey);
                //     this.props.navigation.replace('Home');
                // } else {
                //     if (Platform.OS === 'web') {
                //         alert(i18n.t('wrong_pass_key'));
                //     } else {
                //         Alert.alert(i18n.t('wrong_pass_key'));
                //     }
                // }
            }}
        >
            <Text style={{ color: 'white' }}>{i18n.t('login')}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

export default Login;
